import { organizationSelector } from 'selectors/Organization';
import { selectors as contributorSelectors } from 'reducers/Contributors';
import { Organization, Contributor } from 'stores/organizations/models';
import { createSelector } from 'reselect';

export function contributors(state: any): Contributor[] {
  const organization: Organization | undefined = organizationSelector(state);
  if (organization === undefined) {
    return [];
  }
  return (
    contributorSelectors.contributorsByUUID(state, organization.uuid) ?? []
  );
}

function contributorName(state: any, userName: string) {
  return userName;
}

export function contributorByName(
  contributors: Contributor[],
  userName: string
): Contributor | undefined {
  return contributors.find((contributor) => contributor.username === userName);
}

export const contributor = createSelector(
  [contributors, contributorName],
  contributorByName
);

export const selectors = {
  contributors,
  contributor,
};
